'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-subtle">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-brand mb-4">404</h1>
        <p className="text-xl text-text-secondary mb-8">Страница не найдена</p>
        <Link
          href="/"
          className="px-6 py-3 rounded-xl text-white font-medium"
          style={{ background: 'var(--color-brand)' }}
        >
          На главную
        </Link>
      </div>
    </div>
  );
}
